export const partnerContactsTranslation = {
  contacts: {
    warnings: {
      missedRoles: 'partner_contacts-contacts-warnings-missed_roles',
    },
    controls: {
      segment: {
        all: 'partner_contacts-contacts-controls-segment-all',
        my: 'partner_contacts-contacts-controls-segment-my',
        profiling: 'partner_contacts-contacts-controls-segment-profiling',
        partner: 'partner_contacts-contacts-controls-segment-partner',
        new: 'partner_contacts-contacts-controls-segment-new',
        inactive: 'partner_contacts-contacts-controls-segment-inactive',
      },
      search: 'partner_contacts-contacts-controls-search',
      found: 'partner_contacts-contacts-controls-found',
      actions: {
        add: 'partner_contacts-contacts-controls-actions-add',
        edit: 'partner_contacts-contacts-controls-actions-edit',
        export: 'partner_contacts-contacts-controls-actions-export',
        collapse: 'partner_contacts-contacts-controls-actions-collapse',
        exportSelected: 'partner_contacts-contacts-controls-actions-export_selected',
      },
    },
    table: {
      columns: {
        contactId: 'partner_contacts-contacts-table-columns-contact_id',
        learnerId: 'partner_contacts-contacts-table-columns-learner_id',
        status: 'partner_contacts-contacts-table-columns-status',
        firstName: 'partner_contacts-contacts-table-columns-first_name',
        lastName: 'partner_contacts-contacts-table-columns-last_name',
        email: 'partner_contacts-contacts-table-columns-email',
        hpRoles: 'partner_contacts-contacts-table-columns-hp_roles',
        userStatus: 'partner_contacts-contacts-table-columns-user_status',
        workPhoneNumber: 'partner_contacts-contacts-table-columns-work_phone',
        mobilePhoneNumber: 'partner_contacts-contacts-table-columns-mobile_phone',
        locationId: 'partner_contacts-contacts-table-columns-location_id',
        isNeverCall: 'partner_contacts-contacts-table-columns-never_call',
        isNeverEmail: 'partner_contacts-contacts-table-columns-never_email',
        partnerId: 'partner_contacts-contacts-table-columns-partner_id',
        communicationName: 'partner_contacts-contacts-table-columns-communication_name',
        city: 'partner_contacts-contacts-table-columns-city',
        primary: 'partner_contacts-contacts-table-columns-primary',
        favorite: 'partner_contacts-contacts-table-columns-favorite',
      },
      rowActions: {
        edit: 'partner_contacts-contacts-table-row_actions-edit',
        delete: 'partner_contacts-contacts-table-row_actions-delete',
        star: 'partner_contacts-contacts-table-row_actions-star',
      },
    },
  },
}
